import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-site-section',
  templateUrl: './site-section.component.html',
  styleUrls: ['./site-section.component.scss']
})
export class SiteSectionComponent {
  id: string = "";
  constructor(private route: ActivatedRoute){
    
  }

  ngOnInit(): void {
    this.route.paramMap
    .subscribe(params => {
      this.id = params.get("id")??"";
    })
  }
}
